export const blogs = [
  {
    id: '1',
    title: 'Wat kost een bedrijfswaardering in 2024?',
    slug: 'wat-kost-een-bedrijfswaardering',
    cluster: 'kosten',
    excerpt:
      'Een overzicht van de gemiddelde kosten voor een professionele bedrijfswaardering en welke factoren de prijs bepalen.',
    date: '12 Okt 2023',
    readTime: '5 min',
    image:
      'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '2',
    title: 'Bedrijf waarderen voor verkoop: het complete stappenplan',
    slug: 'bedrijf-waarderen-voor-verkoop',
    cluster: 'verkoop',
    excerpt:
      'Bereid uw bedrijf voor op een succesvolle verkoop met dit uitgebreide stappenplan voor waardebepaling.',
    date: '28 Sep 2023',
    readTime: '8 min',
    image:
      'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '3',
    title: 'EBITDA Multiple uitgelegd: hoe werkt het?',
    slug: 'ebitda-multiple-uitleg',
    cluster: 'methodes',
    excerpt:
      'De EBITDA multiple is een van de meest gebruikte methodes voor bedrijfswaardering. Ontdek hoe u deze toepast.',
    date: '15 Sep 2023',
    readTime: '6 min',
    image:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '4',
    title: 'Bedrijfswaardering bij een echtscheiding: waar moet u op letten?',
    slug: 'bedrijfswaardering-bij-scheiding',
    cluster: 'situaties',
    excerpt:
      'Een echtscheiding is emotioneel zwaar. Een objectieve bedrijfswaardering voorkomt verdere conflicten over de verdeling.',
    date: '02 Sep 2023',
    readTime: '7 min',
    image:
      'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '5',
    title: '5 tips om de waarde van uw bedrijf te verhogen',
    slug: 'hoe-verhoog-je-bedrijfswaarde',
    cluster: 'waarde-verhogen',
    excerpt:
      'Wilt u uw bedrijf over een paar jaar verkopen? Begin nu met het optimaliseren van deze 5 belangrijke waardedrivers.',
    date: '21 Aug 2023',
    readTime: '4 min',
    image:
      'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '6',
    title: 'De meest gemaakte fouten bij een bedrijfswaardering',
    slug: 'fouten-bij-bedrijfswaardering',
    cluster: 'fouten',
    excerpt:
      'Voorkom dat u geld laat liggen of in juridische problemen komt door deze veelvoorkomende fouten te vermijden.',
    date: '10 Aug 2023',
    readTime: '6 min',
    image:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=800',
  },
]

export const advisors = [
  {
    id: '1',
    name: 'Mr. Jeroen van der Berg',
    slug: 'jeroen-van-der-berg',
    company: 'VanderBerg Corporate Finance',
    location: 'Amsterdam',
    bio: 'Jeroen heeft meer dan 15 jaar ervaring in complexe bedrijfswaarderingen, met een specialisatie in IT en zakelijke dienstverlening. Hij is Register Valuator (RV) en begeleidt ondernemers bij zowel verkoop als overname.',
    image:
      'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '2',
    name: 'Drs. Sanne de Vries',
    slug: 'sanne-de-vries',
    company: 'De Vries & Partners',
    location: 'Rotterdam',
    bio: 'Sanne is gespecialiseerd in waarderingen bij echtscheidingen en aandeelhoudersgeschillen. Met haar scherpe analytische blik en empathische aanpak zorgt ze voor helderheid in complexe situaties.',
    image:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '3',
    name: 'Pieter Bakker MSc',
    slug: 'pieter-bakker',
    company: 'Bakker Valuations',
    location: 'Utrecht',
    bio: 'Pieter richt zich primair op het MKB-segment. Hij helpt ondernemers niet alleen met de waardebepaling, maar adviseert ook strategisch over hoe de bedrijfswaarde in de aanloop naar een verkoop verhoogd kan worden.',
    image:
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '4',
    name: 'Emma Visser',
    slug: 'emma-visser',
    company: 'Visser M&A Advies',
    location: 'Eindhoven',
    bio: 'Emma heeft een achtergrond in private equity en brengt deze kennis nu naar MKB-ondernemers. Ze is sterk in financiële modellering en het toepassen van de Discounted Cash Flow methode.',
    image:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '5',
    name: 'Thomas de Jong',
    slug: 'thomas-de-jong',
    company: 'De Jong Corporate',
    location: 'Den Haag',
    bio: 'Thomas begeleidt voornamelijk familiebedrijven bij interne overdrachten. Hij begrijpt de delicate balans tussen zakelijke belangen en familierelaties als geen ander.',
    image:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '6',
    name: 'Lisa Jansen',
    slug: 'lisa-jansen',
    company: 'Jansen Waarderingen',
    location: 'Groningen',
    bio: 'Lisa is een pragmatische adviseur met een focus op de maakindustrie en logistiek. Ze combineert diepgaande sector kennis met gedegen financiële analyses.',
    image:
      'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?auto=format&fit=crop&q=80&w=800',
  },
]

export const cases = [
  {
    id: '1',
    title: 'Succesvolle verkoop van een IT-dienstverlener',
    slug: 'verkoop-it-dienstverlener',
    situatie:
      'De oprichters van een IT-bedrijf (35 medewerkers) wilden na 15 jaar hun bedrijf verkopen aan een grotere strategische partij, maar hadden geen idee van de reële marktwaarde.',
    aanpak:
      'We hebben een uitgebreide waardering uitgevoerd op basis van de DCF-methode, waarbij we de sterke recurring revenue en het eigen IP zwaar hebben meegewogen. Daarnaast hebben we een normalisatie van de management fee toegepast.',
    resultaat:
      'De waardering kwam 30% hoger uit dan de initiële inschatting van de ondernemers. Dit rapport diende als sterk fundament voor de onderhandelingen.',
    conclusie:
      'Een gedegen, onafhankelijke waardering verdient zichzelf ruimschoots terug tijdens het verkooptraject door een sterkere onderhandelingspositie.',
    image:
      'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '2',
    title: 'Waardering bij uittreding aandeelhouder',
    slug: 'uittreding-aandeelhouder-bouwbedrijf',
    situatie:
      'Binnen een bouwbedrijf met drie aandeelhouders ontstond een verschil van inzicht. Eén aandeelhouder wilde uittreden, maar er was onenigheid over de waarde van zijn aandelenpakket van 33%.',
    aanpak:
      'Als onafhankelijk deskundige zijn we door alle partijen gezamenlijk ingeschakeld. We hebben de waarde bepaald en specifiek gekeken naar een eventuele afslag voor een minderheidsbelang en illiquiditeit.',
    resultaat:
      'Er is een objectief rapport opgeleverd dat door alle drie de aandeelhouders is geaccepteerd. De uittredende aandeelhouder is succesvol uitgekocht zonder juridische escalatie.',
    conclusie:
      'Bij interne conflicten is een onafhankelijke, door alle partijen gedragen waardering cruciaal om een dure en langdurige juridische strijd te voorkomen.',
    image:
      'https://images.unsplash.com/photo-1541888086425-d81bb19240f5?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: '3',
    title: 'Bedrijfsoverdracht binnen de familie',
    slug: 'familieoverdracht-productiebedrijf',
    situatie:
      'De eigenaar van een productiebedrijf wilde het stokje overdragen aan zijn dochter. De fiscus eist hierbij een zakelijke waardering om schenkingsrechtelijke problemen te voorkomen.',
    aanpak:
      'We hebben een fiscale waardering opgesteld die voldoet aan alle richtlijnen van de Belastingdienst. Hierbij is rekening gehouden met de specifieke afhankelijkheid van de huidige DGA.',
    resultaat:
      'De waardering is zonder vragen geaccepteerd door de Belastingdienst. De overdracht is fiscaal optimaal en zonder naheffingen verlopen.',
    conclusie:
      'Bij een familieoverdracht is een fiscaal geaccepteerde waardering essentieel om verrassingen achteraf te voorkomen.',
    image:
      'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=800',
  },
]

export const faqs = [
  {
    question: 'Wat is het verschil tussen prijs en waarde?',
    answer:
      'Waarde is een objectieve berekening op basis van toekomstige kasstromen, risicoprofielen en marktomstandigheden. Prijs is het bedrag dat uiteindelijk wordt betaald na onderhandeling. Een bedrijfswaardering geeft u inzicht in de waarde, wat uw onderhandelingspositie voor de uiteindelijke prijs versterkt.',
  },
  {
    question: 'Hoe lang duurt een bedrijfswaarderingstraject?',
    answer:
      'Een standaard bedrijfswaardering duurt gemiddeld 3 tot 5 weken, afhankelijk van de complexiteit van uw onderneming en hoe snel u de benodigde financiële documenten kunt aanleveren.',
  },
  {
    question: 'Welke documenten zijn nodig voor een waardebepaling?',
    answer:
      'Meestal hebben we de jaarrekeningen van de afgelopen 3 tot 5 jaar nodig, actuele tussentijdse cijfers, een prognose voor de komende jaren, en inzicht in eventuele uitzonderlijke baten of lasten (voor normalisatie).',
  },
  {
    question: 'Wat kost een professionele bedrijfswaardering?',
    answer:
      'De kosten variëren afhankelijk van de complexiteit en het doel van de waardering. Voor een MKB-bedrijf liggen de kosten voor een indicatieve waardering vaak tussen de €2.500 en €5.000, terwijl een uitgebreid rapport voor bijvoorbeeld een juridisch geschil of complexe overname tussen de €5.000 en €15.000 kan kosten.',
  },
  {
    question: 'Welke waarderingsmethode wordt het meest gebruikt?',
    answer:
      'De Discounted Cash Flow (DCF) methode wordt academisch en in de praktijk gezien als de meest zuivere methode, omdat deze kijkt naar toekomstige kasstromen. In het MKB wordt daarnaast vaak de EBITDA-multiple methode gebruikt als snelle referentie.',
  },
  {
    question: 'Is een waarderingsrapport bindend?',
    answer:
      'Een waarderingsrapport is in principe een deskundig advies en niet juridisch bindend, tenzij partijen vooraf (bijvoorbeeld in een aandeelhoudersovereenkomst) hebben afgesproken dat het oordeel van de onafhankelijke deskundige bindend is.',
  },
]
